module.exports = __webpack_public_path__ + "img/seo-content-collapsible-hyundai.4f545d77.png";